import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    top: 0,
    width: "100%",
    padding: theme.spacing.space16,
    boxSizing: "border-box",
    height: 70,
    alignItems: "center",
    color: theme.colors.TextDefault,
    background:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%)",
  },
  item: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.space16,
    position: "relative",
    zIndex: 1,
  },
  centerItems: {
    position: "absolute",
    width: "90%",
    justifyContent: "center",
    zIndex: 0,
  },
}));
